import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M31.997 16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.662 2.752.862 5.57.83 8.091",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M.003 16h31.994v.016c.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124.171 21.34-.029 18.521.003 16",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M3.498 3.109 18 16 3.498 28.89C1.425 26.795.866 24.125.866 24.125c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.318.863-8.109 0 0 .559-2.67 2.632-4.766",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M.069 13.333h31.87c.053.92.069 1.82.058 2.683.01.85-.009 1.738-.066 2.65H.061a38 38 0 0 1-.058-2.683c-.01-.85.009-1.737.066-2.65",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M2.552 4.233 16 16 2.552 27.767C1.248 25.95.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 .382-1.825 1.686-3.642",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M.004 15h31.993q.006.516 0 1.016.006.485-.001.984H.003a39 39 0 0 1 0-1.017Q-.003 15.5.004 15",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M1.754 5.54 13.667 16 1.754 26.46c-.67-1.293-.888-2.336-.888-2.336-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.318.863-8.109 0 0 .218-1.042.888-2.335",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M5.073 20C6.398 20 9 19.005 9 15.8S6.225 12 5.395 12 2 12.583 2 15.205s2.515 2.865 3.01 2.865c.496 0 2.355-.437 2.144-2.404 0 .559-.644 1.736-1.995 1.736s-2.193-.983-2.193-1.954c0-.972.818-2.27 2.243-2.27s2.465 1.238 2.465 2.488-1.003 2.84-2.601 2.84z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M4.217 14.646q1.175.437 1.864 1.238a.333.333 0 0 0 .505-.435q-.806-.934-2.136-1.428a.333.333 0 0 0-.233.625"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M6.45 14.646q-1.176.437-1.864 1.238a.333.333 0 0 1-.505-.435q.806-.934 2.136-1.428a.333.333 0 0 1 .232.625"
    }
  )
);
var SvgFlagVut = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagVut_default = SvgFlagVut;

export { FlagVut_default as default };
